import { _ } from '../utils.js'
import loadingSpinner from '../templates/loading.js'
function searchToggle(el) {
    el.addEventListener('click', () => {
        _('searchbox').node().classList.toggle('u-hidden')
    })
}

function trackSearch() {
    document
        .getElementById('search_type')
        ?.addEventListener('submit', function (e) {
            e.preventDefault()
            const searchTerm = document.getElementById('search_type_q').value
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                event: 'siteSearch',
                searchTerm: searchTerm,
            })
            // add loading icon
            document.querySelector('.header__search-items').innerHTML +=
                loadingSpinner()
            document.querySelector('.header__search--button').style.display =
                'none'
            document.getElementById('search_type_q').value = searchTerm
            this.submit()
        })
}

export default {
    searchToggle,
    trackSearch,
}
